module.exports = __webpack_public_path__ + "img/navigate_before_white_32px.f0f15a93.png";